import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#7A472A",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M18.165 7.357c0-2.784-1.723-4.607-4.507-4.607l-6.689.004C4.209 2.771 2.5 4.587 2.5 7.357v9.196c0 2.784 1.722 4.607 4.506 4.607H8m-.754-9.123H9m1-4.177H7.247"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#7A472A",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M21.7 16c0 3.036-2.464 5.5-5.5 5.5s-4.89-3.058-4.89-3.058m0 0h2.487m-2.486 0v2.75M10.7 16c0-3.036 2.441-5.5 5.5-5.5 3.668 0 5.5 3.058 5.5 3.058m0 0v-2.75m0 2.75h-2.443"
    }, null, -1)
  ]))]))
}
export default { render: render }